export default __webpack_public_path__ + "static/media/facebook-incon__grey.d6bd523e.svg";